import React from 'react';
import 'typeface-roboto';

import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

import { Switch, Route, Link, HashRouter as Router, Redirect } from "react-router-dom";

import Home from './pgHome'
import Publications from './pgPublications'
import Benchmarks from './pgBenchmarks'
import Download from './pgDownload'

import { ReactComponent as GithubIcon } from './github.svg';

import logo1 from './non-stratified.gif'
import logo2 from './stratified.gif'

function removeExtraSlash(path) {
  return path.length <= 1 ? path : path.replace(/\/$/, "");
}

export default function App() {
  return (
    <Router>
    <React.Fragment>
      <Grid container justify='center' alignItems='center' style={{ backgroundColor: 'rgb(32,39,42)' }}>
        {/* I want nothing in title to be selectable or draggable. For not being selectable, I use 'className='disableSelect'. For not being draggable, 
            I use 'draggable={false}', but it does not work on Firefox (it works on the others). I found 'onDragStart={(e) => { e.preventDefault() }}' 
            as a solution on https://stackoverflow.com/questions/26356877/html5-draggable-false-not-working-in-firefox-browser */}
        <Grid item key='logo-lft' className='disableSelect'><Box display={{ xs: 'none', md: 'block' }}><img src={logo1} width='128px' alt='' draggable={false} onDragStart={(e) => { e.preventDefault() }}/></Box></Grid>
        <Grid item key='logo-cnt' className='disableSelect' id='title' style={{ marginTop: '20px', marginBottom: '20px' }} >Statistical Model Checker<br />(STMC)</Grid>
        <Grid item key='logo-rgt' className='disableSelect'><Box display={{ xs: 'none', md: 'block' }}><img src={logo2} width='128px' alt='' draggable={false} onDragStart={(e) => { e.preventDefault() }}/></Box></Grid>
      </Grid>
      <AppBar position='sticky' color="default">
        <Toolbar variant='dense'>
          <div style={{ flexGrow: '1' }} />
          <Route
            path="/"
            render={({ location }) => (
              <Tabs value={removeExtraSlash(location.pathname)} indicatorColor="primary" textColor="primary" centered>
                <Tab label="Home"         value="/"             component={Link} to="/" />
                <Tab label="Publications" value="/publications" component={Link} to="/publications" />
                <Tab label="Benchmarks"   value="/benchmarks"   component={Link} to="/benchmarks"   />
                <Tab label="Download"     value="/download"     component={Link} to="/download"     />
              </Tabs>
            )}
          />
          <div style={{ flexGrow: '1' }} />
          <Tooltip title='View the source on GitHub'>
            <IconButton size='small' disableFocusRipple={true} onClick={() => { window.open('https://github.com/nima-roohi/STMC'); }}>
              <GithubIcon style={{ width: '24px', height: '24px' }} />
            </IconButton>
          </Tooltip>
        </Toolbar>
      </AppBar>
      <Switch>
        <Route exact path="/"             component={Home}         />
        <Route       path="/publications" component={Publications} />
        <Route       path="/benchmarks"   component={Benchmarks}   />
        <Route       path="/download"     component={Download}     />
        <Redirect to ="/" />
      </Switch>
    </React.Fragment>    
    </Router>
  );
}
